import React from 'react';
import withStyles from '@mui/styles/withStyles';
import {
	Grid,
	Paper,
	Table,
	Chip,
	TableBody,
	TableContainer,
	TableCell,
	FormHelperText,
	TableHead,
	TableRow,
	Typography,
  styled,
} from '@mui/material';
import {
	ACCESS_MODE,
	Advertisement,
	AdvertisementAsset,
} from '@horasys/bellplus/common/types';
import { VideoTemplateAssetUpload } from './UploadComponents/VideoTemplateAssetUpload';
import { ImageTemplateAssetUpload } from './UploadComponents/ImageTemplateAssetUpload';
import { MultipleImageTemplateAssetUpload } from './UploadComponents/MultipleImageTemplateAssetUpload';
import theme from 'theme';

const PREFIX = 'TemplateDetails';

const classes = {
	head: `${PREFIX}-head`,
	body: `${PREFIX}-body`,
	root: `${PREFIX}-root`,
	formElement: `${PREFIX}-formElement`,
	selectEmpty: `${PREFIX}-selectEmpty`,
	uploadInput: `${PREFIX}-uploadInput`,
	errorMessage: `${PREFIX}-errorMessage`,
	uploadWrapper: `${PREFIX}-uploadWrapper`,
	paperchildGrid: `${PREFIX}-paperchildGrid`,
	saveGrid: `${PREFIX}-saveGrid`,
	margin: `${PREFIX}-margin`,
	table: `${PREFIX}-table`,
	chip: `${PREFIX}-chip`,
	chip1: `${PREFIX}-chip1`,

};

const StyledGrid = styled(Grid)(() => ({
	[`& .${classes.formElement}`]: {
		margin: theme.spacing(0.5),
			minWidth: '100%',
	},

	[`& .${classes.selectEmpty}`]: {
		marginTop: theme.spacing(2),
	},

	[`& .${classes.uploadInput}`]: {
		fontSize: '100px',
		position: 'absolute',
		left: 0,
		top: 0,
		opacity: 0,
	},

	[`& .${classes.errorMessage}`]: {
		color: 'red',
	},

	[`& .${classes.uploadWrapper}`]: {
		position: 'relative',
		overflow: 'hidden',
		display: 'inline-block',
	},

	[`& .${classes.paperchildGrid}`]: {
		padding: theme.spacing(3),
	},

	[`& .${classes.saveGrid}`]: {
		marginTop: theme.spacing(2),
	},

	[`& .${classes.margin}`]: {
		margin: theme.spacing(1),
	},

	[`& .${classes.table}`]: {},
  [`& .${classes.chip}`]: {
    backgroundColor:'#042630'
  },
  [`& .${classes.chip1}`]: {
    backgroundColor:'#e4e5e6',
			color:'rgba(0, 0, 0, 0.87)'
  },
}));



interface Props {
	viewMode: any;
	errorObj: any;
	advertisement: Advertisement;
	mode: ACCESS_MODE;
}
/**
 * Sub-component for 'AdvertisingDetails'. Renders table of assets - video, image.
 */
export default function TemplateDetails(props: Props) {
	const { viewMode, errorObj, advertisement } = props;

	const renderAdvertisementAsset = (
		advertisementAsset: AdvertisementAsset,
		errorObj: any,
	) => {
		switch (advertisementAsset.type) {
			case 'video':
				return (
					<VideoTemplateAssetUpload
						advertisementAsset={advertisementAsset}
						viewMode={viewMode}
						errorObj={errorObj}
					/>
				);

			case 'image':
				return (
					<ImageTemplateAssetUpload
						advertisementAsset={advertisementAsset}
						viewMode={viewMode}
						errorObj={errorObj}
					/>
				);
			case 'multipleImages':
				return (
					<MultipleImageTemplateAssetUpload
						advertisementAsset={advertisementAsset}
						viewMode={viewMode}
						errorObj={errorObj}
					/>
				);
		}
	};

  const getChipBackgroundClass = (data:any) => {
		if (data.isPrimary) {
		  return classes.chip1;
		} else {
		  return classes.chip;
		}
	  };

	return (
		<StyledGrid container>
			{
				<>
					<Grid item xs={12}>
						<FormHelperText className={classes.errorMessage}>
							{/* {errorObj.assets && !Array.isArray(errorObj.assets)
								? errorObj.assets
								: ''} */}
						</FormHelperText>
						<TableContainer component={Paper}>
							<Table className={classes.table}>
								<TableHead>
									<TableRow>
										<StyledTableCell align="center" className={`${classes.head} ${classes.body}`}>
											Type
										</StyledTableCell>
										<StyledTableCell align="center" className={`${classes.head} ${classes.body}`}>
											Best Fit Resolution
										</StyledTableCell>
										<StyledTableCell align="center" className={`${classes.head} ${classes.body}`}>
											Upload
										</StyledTableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{advertisement.templateAssets != null &&
										advertisement.templateAssets.map(
											(data: AdvertisementAsset, index: number) => {
												if (
													data.type != null &&
													data.type &&
													data.type.trim() !== '' &&
													(data.type === 'video' ||
														data.type === 'image' ||
														data.type === 'multipleImages')
												) {
													return (
														<StyledTableRow key={index}>
															<StyledTableCell
																align="center"
																component="th"
																scope="row"

                                >
																<Chip
																	size="medium"
																	label={
																		data.isPrimary
																			? 'PRIMARY ' +
																			data.type.toUpperCase()
																			: data.type.toUpperCase()
																	}
																	color={
																		data.isPrimary
																			? 'secondary'
																			: 'primary'
																	}
                                  className={`${classes.chip} ${getChipBackgroundClass(data)}`}
																/>
															</StyledTableCell>
															<StyledTableCell
																align="center"
																component="th"
																scope="row">
																<Typography variant="h4">
																	{
																		data.templateAsset
																			?.width
																	}
																	x
																	{
																		data.templateAsset
																			?.height
																	}
																</Typography>
															</StyledTableCell>
															<StyledTableCell align="center">
																{renderAdvertisementAsset(
																	data,
																	errorObj.templateAssets &&
																	errorObj
																		.templateAssets
																		.length &&
																	errorObj
																		.templateAssets[
																	index
																	],
																)}
															</StyledTableCell>
														</StyledTableRow>
													);
												} else {
													return <></>;
												}
											},
										)}
								</TableBody>
							</Table>
						</TableContainer>
					</Grid>
				</>
			}
		</StyledGrid>
	);
}

const StyledTableCell = withStyles((theme) => ({
	head: {
		//backgroundColor: theme.palette.common.black,
		backgroundColor: '#085DAD',
		color: theme.palette.common.white,
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);



const StyledTableRow = withStyles((theme) => ({
	root: {
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))(TableRow);


